import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import Grid from '@material-ui/core/Grid'
import Switch from '@material-ui/core/Switch'
import { heightPercentageToDP, widthPercentageToDP } from '../../Utils/ResponsiveScreen'
import Preview from './Preview'
import SendContentPushNotification from '../../Services/Mutations/SendContentPushNotification'

const styles = {
	mandatoryErrorText: {
		fontSize: heightPercentageToDP('2'),
		color: 'red',

	},
	contentCategoryText: {
		fontWeight: 'bold'
	},
	fontSize: {
		fontSize: '12px',
	},
}

class SendPushNotification extends React.Component {

	constructor(props) {
		super(props)
		this.state = {
			approvedContentLanguages: this.props.item.approvedContentLanguages,
			contentModalVisible: false,
			contentCategory1: this.props.item.contentCategory1,
			contentCategory2: this.props.item.contentCategory2,
			contentCategory3: this.props.item.contentCategory3,
			contentDetails: this.props.item,
			selectedPnPriority: this.props.item.pnPriority,
			sendPushNotification: this.props.item.sendPushNotification,
			pnPriorityOptions: [
				{
					label: 'Regular Topic',
					value: 'regularTopic',
					id: 0,
				},
				{
					label: 'Top Stories',
					value: 'topStories',
					id: 1,
				},
			],
			sendPNWithImage: this.props.item.sendPNWithImage ? true : false,
			sendPNWithBigText: this.props.item.sendPNWithBigText,
			pnTitle: this.props.item.pnTitle,
			pnDescription: this.props.item.pnDescription,
			bigTextTitle: this.props.item.bigTextTitle,
			disableSendPN: true ? this.props.item.sendPushNotification == false : false,

		}
	}
	openContentPNModal = (item) => {
		const { contentModalVisible, contentDetails } = this.state
		this.setState({
			contentModalVisible: true,
			approvedContentLanguages: item.approvedContentLanguages,
			contentCategory1: item.contentCategory1,
			contentCategory2: item.contentCategory2,
			contentCategory3: item.contentCategory3,
			contentDetails: item,
			selectedPnPriority: item.pnPriority,
			sendPushNotification: item.sendPushNotification,
			sendPNWithImage: item.sendPNWithImage ? true : false,
			pnTitle: item.pnTitle,
			pnDescription: item.pnDescription,
			bigTextTitle: item.bigTextTitle,
			disableSendPN: true ? item.sendPushNotification == false : false,
		})
	}
	closeContentPNModal = () => {
		this.setState({
			contentModalVisible: false,
			approvedContentLanguages: this.props.item.approvedContentLanguages,
			contentCategory1: this.props.item.contentCategory1,
			contentCategory2: this.props.item.contentCategory2,
			contentCategory3: this.props.item.contentCategory3,
			contentDetails: this.props.item,
			selectedPnPriority: this.props.item.pnPriority,
			sendPushNotification: this.props.item.sendPushNotification,
			sendPNWithImage: this.props.item.sendPNWithImage,
			pnTitle: this.props.item.pnTitle,
			pnDescription: this.props.item.pnDescription,
			bigTextTitle: this.props.item.bigTextTitle,
			disableSendPN: true ? this.props.item.sendPushNotification == false : false,
		})
	}
	handleSendNotification = (e) => {
		this.setState({ sendPushNotification: e.target.checked, disableSendPN: !this.state.disableSendPN })
	}
	handlePnPriority = (priority) => {
		this.setState({ selectedPnPriority: priority })
	}
	handleChangeSendPNWith = () => {
		const bigTitle = (this.state.pnDescription != null && this.state.pnDescription != undefined && this.state.pnDescription != '') ? this.state.pnDescription : this.props.item.bigTextTitle
		this.setState({ sendPNWithImage: !this.state.sendPNWithImage, bigTextTitle: bigTitle })
	}
	handlePNTitle = (e) => {
		const pnTitle = e.target.value.substring(0, 45)
		this.setState({ pnTitle: pnTitle })
	}
	handlebigTextTitle = (e) => {
		this.setState({ bigTextTitle: e.target.value })
	}
	handlePNDescription = (e) => {
		const pnDescription = e.target.value.substring(0, 240)
		this.setState({ pnDescription: e.target.value })
	}
	sendPnValidation = () => {
		const { sendPushNotification, pnDescription, sendPNWithBigText, sendPNWithImage, pnTitle, bigTextTitle } = this.state
		const pnTextValidation = sendPNWithImage ? (pnTitle != null && pnTitle != undefined && pnTitle != '') : (bigTextTitle != undefined && bigTextTitle != null && bigTextTitle != '')
		// const bigTextTitleValidation = sendPNWithImage === false ? (pnDescription != null && pnDescription != undefined && pnDescription != '') : pnTextValidation
		const sendPnValidation = sendPushNotification ? (pnTextValidation) : true
		// this.setState({ disableSendPN: !this.state.disableSendPN })

		return !sendPnValidation
	}

	sendPn = async (contentDetails) => {
		const { selectedPnPriority, pnTitle, pnDescription, bigTextTitle, sendPNWithImage, sendPushNotification } = this.state
		const pnInput = {
			PK: contentDetails.PK,
			SK: contentDetails.SK,
			pnPriority: selectedPnPriority,
			pnTitle: pnTitle,
			pnDescription: pnDescription,
			bigTextTitle: bigTextTitle,
			sendPNWithImage: sendPNWithImage,
			sendPushNotification: sendPushNotification,
		}
		if (this.state.approvedContentLanguages.length == 1) {
			this.state.approvedContentLanguages.map((item, index) => (
				pnInput[`pnTitle_${item}`] = pnTitle,
				pnInput[`pnDescription_${item}`] = pnDescription,
				pnInput[`bigTextTitle_${item}`] = bigTextTitle

			))
		} else {
			//add code for multi language when needed
		}

		console.log(pnInput, "============pnInput")
		const response = await SendContentPushNotification(pnInput)
		console.log(response, 'SendContentPushNotification111111===========')

		if (response.statusCode == 'A359') {
			this.props.displayToast('success', 'Initiated Sending Push Notification')
		} else {
			this.props.displayToast('error', 'Failed To Send Push Notification')
		}
		this.setState({
			contentModalVisible: false
		})

	}
	renderCategories = () => {
		const { contentDetails, contentCategory1, contentCategory2, contentCategory3 } = this.state
		const categoryData = contentCategory1 ? contentCategory1 : ''
		const levelData = contentCategory2 && contentCategory2 != 'All' ? '->' + contentCategory2 : ''
		const sublevelData = contentCategory3 && contentCategory3 != 'All' ? '->' + contentCategory3 : ''
		const contentCategory = categoryData + levelData + sublevelData
		return (
			<div>
				<text style={styles.contentCategoryText}>Content Category:</text>
				<text>{contentCategory}</text>
			</div>
		)
	}

	renderContentPNModal = (item) => {
		const {
			contentModalVisible,
			contentDetails,
			selectedPnPriority,
			sendPNWithImage,
			pnTitle,
			pnDescription,
			bigTextTitle,
			pnPriorityOptions,
			sendPushNotification,
			disableSendPN,
		}
			= this.state
		const sendPn = sendPushNotification === false ? disableSendPN : this.sendPnValidation()
		const height = contentDetails.contentType === 'Story' ? '92%' : '102%'
		return (
			<div>
				<Modal show={contentModalVisible} onHide={() => this.closeContentPNModal()} size='lg'>
					<Modal.Body>
						<div class='row col-md-10'>
							<div
								class='col-md-6'
								style={{
									borderStyle: 'solid',
								}}
							>
								<div className='custom-control custom-switch'>
									<input
										type='checkbox'
										className='custom-control-input'
										onChange={this.handleSendNotification}
										checked={sendPushNotification}
										id='sendPushNotification'
										readOnly
									/>
									<label className='custom-control-label' htmlFor='sendPushNotification'>
										Send Push Notification
									</label>
								</div>
								{sendPushNotification ? (
									<div>
										<div>
											{pnPriorityOptions.map((item, index) => (
												<div style={{ marginRight: 10 }}>
													<input
														value={selectedPnPriority}
														type='radio'
														checked={selectedPnPriority == item.value}
														onChange={() => {
															this.handlePnPriority(item.value)
														}}
													></input>
													<text for={item.value}>{item.label}</text>
												</div>
											))}
										</div>
										<div clss='row'>
											<Grid component='label' container alignItems='center' spacing={1}>
												<Grid item>With Big Text</Grid>

												<Grid item>
													<Switch
														checked={sendPNWithImage}
														onChange={() => this.handleChangeSendPNWith()}
														value='checkedA'
													/>
												</Grid>
												<Grid item>With Image</Grid>
											</Grid>
										</div>
										<text for='text'>PN Title :
										</text>
										<div>
											<input
												maxLength={65}
												type='text'
												onChange={(value) => {
													this.handlePNTitle(value)
												}}
												value={pnTitle ? pnTitle.substring(0, 65) : ''}
												placeholder='Please Enter PN Title'
											></input>
										</div>
										{!sendPNWithImage ? (
											<div>
												<text for='text'>Big Text : </text>
												<div>
													<textarea
														type='text'
														onChange={(value) => {
															this.handlebigTextTitle(value)
														}}
														value={bigTextTitle}
														placeholder='Please Enter Big Text'
													></textarea>
												</div>
											</div>
										) : (
											<div>
												<text for='text'> PN Description : </text>
												<div>
													<textarea
														maxLength={240}
														type='text'
														onChange={(value) => {
															this.handlePNDescription(value)
														}}
														value={pnDescription ? pnDescription.substring(0, 240) : ''}
														placeholder='Please Enter PN Description'
													></textarea>
												</div>
											</div>
										)}
									</div>
								) : null
								}

								{this.sendPnValidation() ? (
									<text style={styles.mandatoryErrorText}>{'Please fill pn all fields'}</text>
								) : null}

								<div class='row'>
									<div style={{ textAlign: 'center', marginTop: 10 }}>
										<Button
											onClick={() => {
												this.closeContentPNModal()
											}}
										>
											Cancel
										</Button>
										<Button
											style={{ marginLeft: 10 }}
											onClick={() => {
												this.sendPn(contentDetails)
											}}
											disabled={sendPn}
										>
											Send PN
										</Button>
									</div>
								</div>
							</div>
							<div class='col-md-1'></div>
							<div class='col-md-4'>
								{this.renderCategories()}
								<div
									style={{
										height: heightPercentageToDP(height),
										width: widthPercentageToDP('100%'),
										borderStyle: 'solid',
										position: 'relative',
									}}
								>

									<Preview
										data={item}
										// createAs={this.state.createAs}
										// selectedContributor={selectedContributor}
										contentSelectedLangVal={this.state.approvedContentLanguages[0]}
									/>
								</div>
							</div>
							{/* <Modal.Footer> */}

							{/* </Modal.Footer> */}
						</div>
					</Modal.Body >
				</Modal >
			</div >
		)
	}
	render() {
		const { item } = this.props
		const { sendPNWithImage } = this.state
		return (

			<>


				{this.props.rank ? (
					<div
						onClick={() => {
							this.openContentPNModal(item)
						}}
					>
						<label> Send Push Notification</label>
					</div>
				) : (
					<div
						data-toggle='tooltip'
						title={`Send PN`}
						style={{ fontSize: '12px' }}
						class={this.props.rank ? '' : 'col-md-3 faIconClass'}
						onClick={() => {
							this.openContentPNModal(item)
						}}
					>
						<i class='fa fa-bell' />
					</div>
				)}
				{this.renderContentPNModal(item)}

			</>

		)
	}
}

export default SendPushNotification
